import { Loader } from "@launchmetrics/lm-ui";
import Session from "components/LM/Auth/Session";
import DateFormat from "components/LM/common/DateFormat";
import ModalDisplay from "components/LM/common/ModalDisplay";
import K2Api from 'lib/ajax/K2Api';
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Info as InfoIcon } from "react-feather";
import { Button } from "reactstrap";

function ProfileRecovery(props) {
	const { type, typeName, profile, canRecover } = props;

	const buttonText = 'Yes, run the historical recovery';
	const [recoverButtonText, setRecoverButtonTextState] = useState(buttonText);
	const [recoveryState, setRecoveryState] = useState(true);
	const [recoveryMessage, setRecoveryMessage] = useState(null);
	const [showRecoveryModal, setShowRecoveryModalState] = useState(false);
	const session = new Session();

	const beginDate = new Date();
	beginDate.setUTCMonth(beginDate.getMonth() - 13);
	beginDate.setUTCDate(1);
	beginDate.setUTCHours(0, 0, 0);
	const endDate = new Date();

	useEffect(() => {
		const fetchData = async () => {
			const k2Api = new K2Api();
			const recoveryStatus = await k2Api.get(`/socialmedia/${type}/recovery/${profile.info.id}`);
			setRecoveryState(recoveryStatus.data.can_recover);
			setRecoveryMessage(recoveryStatus.data.reason);
		}
		if (canRecover) fetchData();
	}, [type, profile.info.id, canRecover]);


	const triggerRecovery = async () => {
		setRecoverButtonTextState(<><Loader styleProps={{ marginLeft: '10px'}}size={20} />{buttonText}</>);
		setRecoveryState(false);
		setRecoveryMessage("Recovery already in progress for this profile");
		try {
			const k2Api = new K2Api();
			const response = await k2Api.post(
				`/socialmedia/${type}/recovery`,
				{ id: profile.info.id, begin_date: beginDate, end_date: endDate }
			);
			if (response) setShowRecoveryModalState(!showRecoveryModal);
		} catch (err) {
			console.error(err);
		}
	}

	const recoveryButton = (reason) => {
		let toolTip;
		if (!canRecover || !recoveryState) {
			toolTip = <Tooltip>{reason}</Tooltip>;
		}

		return (
			<>
				<Button color="primary" onClick={() => { setShowRecoveryModalState(!showRecoveryModal) }} disabled={!recoveryState || !canRecover} className="mt-2" size="sm">
					Recover historical data
				</Button>
				{
					toolTip && <OverlayTrigger placement="bottom" overlay={toolTip}>
						<InfoIcon size={24} className={"text-warning ml-1 align-bottom"} />
					</OverlayTrigger>
				}
			</>
		)
	};

	const getContentText = (type, typeName, beginDate, endDate) => {
		const baseText = [
			`This action will recover all the posts from this ${formattedType(type)} ${typeName} from `,
			<DateFormat key={beginDate} showOnlyDate={true}>{beginDate}</DateFormat>,
			" to ",
			<DateFormat key={endDate} showOnlyDate={true}>{endDate}</DateFormat>,
		];

		if (['douyin', 'bilibili'].includes(type)) {
			return [...baseText, `, with a maximum of 200 posts. Do you want to proceed?`];
		} else if (type === 'wechat_public') {
			return [...baseText, `, with a maximum of 100 posts. Do you want to proceed?`];
		} else {
			return [...baseText, `. Do you want to proceed?`];
		}
	};

	return (
		<>
			{recoveryButton(profile.recovery?.reason || recoveryMessage)}
			<ModalDisplay
				isVisible={showRecoveryModal}
				headerText={"Historical recovery for " + profile.info.name}
				contentText={getContentText(type, typeName, beginDate, endDate)}
				confirmButtonText={recoverButtonText}
				disableConfirmButton={!session.hasPermission("social_recovery") || !recoveryState}
				onCancel={() => setShowRecoveryModalState(!showRecoveryModal)}
				onConfirm={() => triggerRecovery()}
			/>
		</>
	);
}

function formattedType(type) {
	return (type === 'wechat_public') ? 'wechat' : type;
}

export default ProfileRecovery;
